import React, { useEffect } from 'react';
import './style.scss';
import imgURL from '../../lib/imgURL';
import CustomStepper from '../../components/CustomStepper';
import useRedirect from '../../hooks/useRedirect';

const PublicSelfServeLayout = ({ children }) => {

    const { path } = useRedirect();

    const [stepperData, setStepperData] = React.useState<string[]>([]);

    useEffect(() => {
        if(path === '/user-verification/kyc-sign-agreement-director') {
            setStepperData(prevData => [...prevData, 'KYC & Sign Agreement']);
        } else if(path === '/user-verification/upload-documents-director') {
            setStepperData(prevData => [...prevData, 'Upload documents']);
        }
        else if(path === '/user-verification/upload-documents-company-director') {
            setStepperData(prevData => [...prevData, 'Business verification']);
        }
    }, [path]);

    return (
        
        <div className='public-self-serve-layout'>
            <div className='public-side-bar'>
                <img src= {imgURL['plural-online']} />
                <div className='stepper-container'>
                <CustomStepper numberOfSteps={stepperData.length} stepperData={stepperData} currentStep={0}/>
                </div>
            </div>
            <div className='public-content-area'>
                {children}
            </div>
        </div>
    ); 
};

export default PublicSelfServeLayout;
